import { IUserTeamRoles } from '../interfaces/user-team-roles.interface';
import { UserTeamRoleEnum } from './user-team-role.enum';

// @dynamic
export class UserTeamRoles {
    static all: IUserTeamRoles[] = [
        {
            name: 'team_leader',
            value: UserTeamRoleEnum.LEAD,
            translationLabel: 'TEAMS.LEAD.TITLE',
        },
        {
            name: 'team_member',
            value: UserTeamRoleEnum.MEMBER,
            translationLabel: 'TEAMS.MEMBER.SINGULAR',
        },
        {
            name: 'team_watcher',
            value: UserTeamRoleEnum.WATCHER,
            translationLabel: 'TEAMS.WATCHER.TITLE.SINGULAR',
        },
        {
            name: 'team_leader_sub_teams',
            value: UserTeamRoleEnum.WATCHER,
            translationLabel: 'TEAMS.TEAM_LEADER_SUBTEAMS.TITLE',
        },
    ];
}
